import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// Enhanced browser diagnostics for staging/production
if (import.meta.env.VITE_APP_ENV === 'staging' || import.meta.env.VITE_APP_ENV === 'production') {
  console.log('='.repeat(80));
  console.log('ADMIN APP STARTUP DIAGNOSTICS');
  console.log('='.repeat(80));
  console.log('Timestamp:', new Date().toISOString());
  console.log('Window location:', window.location.href);
  console.log('Protocol:', window.location.protocol);
  console.log('Hostname:', window.location.hostname);
  console.log('Port:', window.location.port || '(default)');
  console.log('API Base URL:', import.meta.env.VITE_API_BASE_URL);
  console.log('Environment:', import.meta.env.VITE_APP_ENV);
  console.log('Use Mock Auth:', import.meta.env.VITE_USE_MOCK_AUTH);
  console.log('User Agent:', navigator.userAgent);
  console.log('='.repeat(80));
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)